var _ellipse, _ellipse2, _g, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _line, _ellipse7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 63.5228,
    rx: 60,
    ry: 60.0421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1613_6793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 120,
    height: 121
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 63.9579,
    rx: 60,
    ry: 60.0421,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1613_6793)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.0001,
    cy: 143.797,
    rx: 45.2174,
    ry: 52.8632,
    fill: "#4BC3B5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0435,
    y: 52.646,
    width: 93.913,
    height: 24.3649,
    rx: 5,
    fill: "#4BC3B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9565,
    y: 47.8596,
    width: 86.5217,
    height: 34.3719,
    rx: 5,
    fill: "#48BAAD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7393,
    y: 45.249,
    width: 75.2174,
    height: 39.1579,
    rx: 5,
    fill: "#4BC3B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0435 47.3921C23.0435 41.7156 27.0218 36.7787 32.6096 35.7798C52.7987 32.1707 66.775 32.1623 86.5713 35.7546C92.1371 36.7645 96.0869 41.6919 96.0869 47.3486V82.9212C96.0869 88.6093 92.0864 93.4946 86.4503 94.2617C79.717 95.1781 70.0769 96.1544 59.5652 96.1544C49.0535 96.1544 39.4134 95.1781 32.6801 94.2617C27.044 93.4946 23.0435 88.6093 23.0435 82.9212V47.3921Z",
    fill: "#48BAAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1304 54.7145C29.1304 48.9217 33.2688 43.9118 38.9991 43.063C54.5193 40.7641 65.817 40.7567 81.045 43.0408C86.7564 43.8975 90.8695 48.9 90.8695 54.6754V75.2896C90.8695 81.0742 86.7405 86.0145 80.9923 86.6619C75.4381 87.2874 68.0191 87.8876 59.9999 87.8876C51.9808 87.8876 44.5618 87.2874 39.0076 86.6619C33.2594 86.0145 29.1304 81.0742 29.1304 75.2896V54.7145Z",
    fill: "#4BC3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4346 55.6912C30.4346 49.8898 34.5827 44.8726 40.3245 44.0433C54.8165 41.9504 65.4973 41.9433 79.7194 44.0219C85.4428 44.8583 89.565 49.8683 89.565 55.6525V74.3335C89.565 80.0876 85.4728 85.0123 79.7564 85.6694C74.4771 86.2762 67.5135 86.8472 59.9998 86.8472C52.4861 86.8472 45.5225 86.2762 40.2432 85.6694C34.5268 85.0123 30.4346 80.0876 30.4346 74.3335V55.6912Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6523 72.6597H64.348C64.348 75.0609 62.4014 77.0105 60.0002 77.0105C57.5989 77.0105 55.6523 75.0609 55.6523 72.6597Z",
    fill: "#373838"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.3042,
    cy: 64.8279,
    rx: 3.91304,
    ry: 3.91579,
    fill: "#373838"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2173,
    cy: 65.4803,
    rx: 1.08696,
    ry: 1.08772,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.3911,
    cy: 64.8279,
    rx: 3.91304,
    ry: 3.91579,
    fill: "#373838"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.3042,
    cy: 65.4803,
    rx: 1.08696,
    ry: 1.08772,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5869,
    y1: 3.91577,
    x2: 16.5869,
    y2: 55.2561,
    stroke: "#4BC3B5"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5216,
    cy: 2.17544,
    rx: 2.17391,
    ry: 2.17544,
    fill: "#4BC3B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotAvatar);
export default __webpack_public_path__ + "static/media/robotAvatar.6b78b2d171c7d7f5956ffb59a7caa390.svg";
export { ForwardRef as ReactComponent };